import { createContext, useEffect, useState } from 'react';
import { Navigate, useNavigate, useRoutes } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import axiosInstance from './api';
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import SERVER_API_URL from './config';
import { HomePage, DistrictList, ChurchList } from './pages/landing';
import { LoginPage, ForgetPasswordPage, GetVerificationCodePage, SetNewPasswordPage } from './pages/auth';
import {
  DashboardAppPage,
  DistrictPage,
  ChurchPage,
  RolePage,
  UserPage,
  CategoryPage,
  Page404,
  ProfilePage,
  ChatPage,
  SettingPage,
  ContactPage,
  PaymentPage,
  DioceseChurchPage,
  DioceseUserPage,
  ConfessorChild
} from './pages';

export const authContext = createContext({
  user: {},
  setUser: (info) => {
    let infoT = info;
    infoT = '';
    console.log(infoT);
  },
  getUserData: () => { },
  isLoggedIn: false,
  setIsLoggedIn: (auth) => {
    let authC = auth;
    authC = '';
    console.log(authC);
  },
  handleLogin: () => { },
});

export default function Router() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem('theme')) {
      localStorage.setItem('theme', 'light');
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('id');

    if (token) {
      const decodedToken = jwtDecode(token);
      const expirationDate = new Date(decodedToken.exp * 1000);

      if (expirationDate < new Date()) {
        setIsLoggedIn(false);
        localStorage.clear();
        navigate('/landing');
      } else {
        setIsLoggedIn(true);
      }
    } else {
      setIsLoggedIn(false);
    }

    if (token && id) {
      getUserData(id);
    }
  }, [navigate]);

  const getUserData = async (id) => {
    let userId = id;
    userId = '';
    console.log(userId);
    try {
      const response = await axiosInstance.post(`${SERVER_API_URL}/auth/getme`);
      if (response.status === 200) {
        setUser(response.data);
      }
    } catch (e) {
      if (e.code === 'ERR_NETWORK') {
        // Handle network error
      } else if (e.response.status === 404) {
        localStorage.removeItem('id');
        localStorage.removeItem('token');
      } else if (e.request) {
        // Handle request error
      }
    }
  };

  const handleLogin = () => {
    setIsLoggedIn(true);
    getUserData(localStorage.getItem('id'));
    navigate('/dashboard');
  };

  const routes = useRoutes([
    {
      element: (
        <authContext.Provider
          value={{
            isLoggedIn,
            setIsLoggedIn,
            getUserData,
            user,
            setUser,
            handleLogin,
          }}
        >
          <SimpleLayout />
        </authContext.Provider>
      ),
      children: [
        { element: <Navigate to="/landing" />, index: true },
        { path: 'landing', element: <HomePage /> },
        { path: '/login', element: <LoginPage /> },
        { path: '/forgetPassword', element: <ForgetPasswordPage /> },
        { path: '/getVerificationCode', element: <GetVerificationCodePage /> },
        { path: '/setNewPassword', element: <SetNewPasswordPage /> },
        { path: '/districtList', element: <DistrictList /> },
        { path: '/churchList', element: <ChurchList /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '/dashboard',
      element: (
        <authContext.Provider
          value={{
            isLoggedIn,
            setIsLoggedIn,
            getUserData,
            user,
            setUser,
            handleLogin,
          }}
        >
          <DashboardLayout />
        </authContext.Provider>
      ),
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'dioceseChurch', element: <DioceseChurchPage /> },
        { path: 'dioceseUser', element: <DioceseUserPage /> },
        { path: 'confessorChild', element: <ConfessorChild /> },
        { path: 'user', element: <UserPage /> },
        { path: 'district', element: <DistrictPage /> },
        { path: 'church', element: <ChurchPage /> },
        { path: 'role', element: <RolePage /> },
        { path: 'category', element: <CategoryPage /> },
        { path: 'chat', element: <ChatPage /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'setting', element: <SettingPage /> },
        { path: 'contact', element: <ContactPage /> },
        { path: 'payment', element: <PaymentPage /> },
      ],
    },
    {
      element: (
        <authContext.Provider
          value={{
            isLoggedIn,
            setIsLoggedIn,
            getUserData,
            user,
            setUser,
            handleLogin,
          }}
        >
          <SimpleLayout />
        </authContext.Provider>
      ),
      children: [
        {
          element: (
            <>
              <Navigate to="/dashboard/app" />, index: true
            </>
          ),
        },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
